import { render, staticRenderFns } from "./FeesTabs.vue?vue&type=template&id=6c17e72c&scoped=true"
import script from "./FeesTabs.vue?vue&type=script&lang=js"
export * from "./FeesTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c17e72c",
  null
  
)

export default component.exports